import {LEAGUE_CONFIGS} from "../../configs/leagues";

export function getLeagueByRating(rating) {
  const safeRating = Math.max(0, rating || 0);
  let result = LEAGUE_CONFIGS[0];
  for (const league of LEAGUE_CONFIGS) {
    if (safeRating >= league.minRating) {
      result = league;
    } else {
      break;
    }
  }
  return result;
}

export function getLeagueClassName(rating) {
  return `league-${getLeagueByRating(rating).id}`;
}
